import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function OrderFailed() {
  const [params] = useSearchParams();
  const orderId = params.get("orderId");

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] bg-gray-50 px-6 text-center">
      <XCircle className="w-20 h-20 text-red-500 mb-6" />
      <h1 className="text-3xl font-bold text-gray-800 mb-2">
        Payment didn't go through
      </h1>
      <p className="text-gray-600 max-w-md mb-2">
        Your payment could not be completed and you have not been charged. You
        can try again or choose a different payment method.
      </p>
      {orderId && (
        <p className="text-sm text-gray-500 mb-8">
          Order reference: <span className="font-mono">{orderId}</span>
        </p>
      )}
      <div className="flex gap-3">
        <Link
          to="/checkout"
          className="bg-brand text-black font-semibold px-8 py-3 rounded-xl hover:bg-black hover:text-brand transition-all"
        >
          Try Again
        </Link>
        <Link
          to="/"
          className="border border-gray-300 text-gray-700 font-semibold px-8 py-3 rounded-xl hover:bg-gray-100 transition-all"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
